import Theme from '@jetbrains/ring-ui-built/components/global/theme'
import {trackEvent} from '@jetbrains/teamcity-ui/dist/statistics'
import {useEffect} from 'react'

import {useAppDispatch, useAppSelector} from '../../../hooks/react-redux'
import {useBooleanUserProperty, useUserProperty} from '../../../hooks/useUserProperty'
import {getServerInfo} from '../../../selectors'
import {isWelcomePopupEnabled} from '../../../utils/featureToggles'
import {UserProperties} from '../../../utils/userProperties'

import WelcomePopup from './WelcomePopup'
import {resolveMajorVersion} from './WelcomePopup.versions'

import {openWhatsNew} from 'src/actions'
import {useDarkOrLightTheme} from 'src/hooks/theme/useDarkOrLightTheme'
import {useSetUserProperty} from 'src/hooks/useSetUserProperty'

function WelcomePopupContainer() {
  const showPopup = useBooleanUserProperty(UserProperties.SHOW_WELCOME_POPUP, true)
  const setUserProperty = useSetUserProperty()
  const dispatch = useAppDispatch()
  const onClose = () => {
    setUserProperty(UserProperties.SHOW_WELCOME_POPUP, 'false')
    trackEvent({name: 'close.click', groupId: 'welcomepopup.events.group'})
    dispatch(openWhatsNew())
  }
  const onCallToActionClick = () => onClose()

  const theme = useDarkOrLightTheme()

  const serverBuildNumber = useAppSelector(state => getServerInfo(state)?.buildNumber)
  const serverDisplayVersion = useAppSelector(state => getServerInfo(state)?.version)
  const serverMajorVersion = resolveMajorVersion(serverDisplayVersion, serverBuildNumber)

  const userBuildNumber = useUserProperty(UserProperties.SERVER_BUILD_NUMBER)
  const userDisplayVersion = useUserProperty(UserProperties.SERVER_DISPLAY_VERSION)
  const userMajorVersion = resolveMajorVersion(userDisplayVersion, userBuildNumber)

  const isOldUser = Boolean(
    userBuildNumber &&
    serverBuildNumber &&
    Number(userBuildNumber) < Number(serverBuildNumber) &&
    userMajorVersion !== serverMajorVersion,
  )
  const canBeShown = isWelcomePopupEnabled() && isOldUser

  useEffect(() => {
    if (showPopup && canBeShown) {
      trackEvent({name: 'welcome.popup.open', groupId: 'welcomepopup.events.group'})
    }
  }, [canBeShown, showPopup])

  return (
    <WelcomePopup
      show={showPopup && canBeShown}
      isDark={theme === Theme.DARK}
      onClose={onClose}
      onCallToActionClick={onCallToActionClick}
    />
  )
}
export default WelcomePopupContainer
